<template>
	<div class="canvas">
		<div class="config">
			<div>
				<select class="form-select" @change="set_enviroment($event.target.value)" :disabled="tests.run">
					<option v-for="environment in configuration.environments" :value="environment.value" :key="environment.value">
						{{environment.name}}
					</option>
				</select>
			</div>
			<div>
				<input type="number" v-model="configuration.speed" class="form-control" placeholder="Velocidad" min="3" max="60" :disabled="tests.run">
			</div>
			<div>
				<MDBBtn :disabled="!can_push_the_button" :color="tests.run ? 'info' : 'success'" @click="toggle_tests()">{{tests.run ? 'Detener' : 'Iniciar'}}</MDBBtn>
			</div>
		</div>

		<div class="detail">
		</div>

		<div class="tests">
			<div class="ping" v-if="have_ping_results">
				<table>
					<thead>
						<tr>
							<th class="ping-column" v-for="column in tests.ping.columns" :key="column.key">
								{{column.name}}
							</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="server in tests.ping.servers" :key="server">
							<template v-for="(pings, instance) in tests.ping.results[server]" :key="instance">
								<tr>
									<td class="ping-column" v-for="column in tests.ping.columns" :key="column.key" :style="rgb_pill(pings[0][column.key].value, pings[0][column.key].limit)">
										<div v-if="column.key === 'general'" class="ping-first-column">
											<span class="ping-key">
												<div>{{server}}</div>
												<div>{{instance}}</div>
											</span>
											<span class="ping-value">
												<div>{{format_test_ping_value(server, instance, column.key)}} {{column.unit}}</div>
												<div>{{tests.ping.results[server][instance].length}} pruebas</div>
											</span>
										</div>
										<div v-else>
											<span class="ping-value">{{format_test_ping_value(server, instance, column.key)}} {{column.unit}}</span>
										</div>
									</td>
								</tr>
							</template>
						</template>
					</tbody>
					<tfoot></tfoot>
				</table>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'SystemStatus',
		components: {},
		data() {
			return {
				configuration: {
					fleet: 'develop',
					speed: 5,
					blue: 64,
					worker: {
						username: undefined,
						password: undefined
					},
					operator: {
						username: undefined,
						password: undefined
					},
					environments: [
					{
						value: 'production',
						name: 'Producción'
					},
					{
						value: 'staging',
						name: 'Staging'
					},
					{
						value: 'test-1',
						name: 'Test I'
					},
					{
						value: 'test-2',
						name: 'Test II'
					},
					{
						value: 'local',
						name: 'Local'
					}
					],
					workers: [],
					operators: [],
				},
				tests: {
					run: false,
					ping: {
						servers: ['api', 'centralserver', 'notifications'],
						columns: [
						{
							key: 'general',
							name: 'servidor',
							unit: 'ms',
							index: 1
						},
						{
							key: 'cpu',
							name: 'cpu',
							unit: '%',
							index: 2
						},
						{
							key: 'memory',
							name: 'memoria',
							unit: '%',
							index: 3
						},
						{
							key: 'tables',
							name: 'tablas',
							unit: 'ms',
							index: 4
						},
						{
							key: 'queues',
							name: 'colas',
							unit: 'ms',
							index: 5
						},
						{
							key: 'firebase',
							name: 'firebase',
							unit: 'ms',
							index: 6
						},
						{
							key: 'blobs',
							name: 'archivos',
							unit: 'ms',
							index: 7
						},
						{
							key: 'emails',
							name: 'correos',
							unit: 'ms',
							index: 8
						}
						],
						id: undefined,
						limit: 3000,
						results: {},
						ttl: 1000 * 60 * 5,
						key: 'BE405F3C81CEB43ECE47E0D6234D4247'
					}
				}
			};
		},
		mounted() {
			this.set_enviroment(this.configuration.environments[0].value)
			this.$fieldbeat.authorize_as_basic(localStorage.user, localStorage.pass)
		},
		computed: {
			can_push_the_button() {
				return !!this.configuration.speed
			},
			have_ping_results() {
				return Object.keys(this.tests.ping.results).length > 0
			}
		},
		methods: {
			set_enviroment(environment) {
				this.$fieldbeat.set_environment(environment)
			},
			toggle_tests() {
				this.tests.run = !this.tests.run

				if(this.tests.run) {
					this.tests.ping.results = {}

					this.run_ping_test()
				}
			},
			run_ping_test() {
				if(!this.tests.run) {
					return
				}

				if(this.tests.ping.id) {
					clearTimeout(this.tests.ping.id)
				}

				const now = Date.now()
				let todo = this.tests.ping.servers.length

				for(const server of this.tests.ping.servers) {
					this.$fieldbeat.ping(server, this.tests.ping.key).then(response => {
						if(!response || !response.json) {
							todo++
							this.tests.ping.id = setTimeout(this.run_ping_test, 1000  * this.configuration.speed)
							return
						}

						const ping = {}
						const server_id = response.json.server_id.split('-').pop().toLowerCase()

						delete response.json.server_id

						ping.general = {
							date: now,
							limit: this.tests.ping.limit,
							value: response.duration,
							error: response.code !== 200,
							duration: response.duration,
						}

						for(const key1 of Object.keys(response.json)) {
							response.json[key1].date = now

							if(response.json[key1].status) {
								response.json[key1].detail = {}

								for(const key2 of Object.keys(response.json[key1].status)) {
									response.json[key1].detail[key2] = {
										date: now,
										error: false,
										value: response.json[key1].status[key2],
									}
								}

								delete response.json[key1].status
							}
						}

						this.tests.ping.results[server] = this.tests.ping.results[server] || {}
						this.tests.ping.results[server][server_id] = this.tests.ping.results[server][server_id] || []
						this.tests.ping.results[server][server_id].unshift({...ping, ...response.json})

						if(--todo === 0) {
							this.tests.ping.id = setTimeout(this.run_ping_test, 1000  * this.configuration.speed)
						}
					})
				}
			},
			format_test_ping_value(server, instance, test) {
				let value = this.tests.ping.results[server][instance][0][test].value

				if(value % 1 === 0) {
					value = value.toLocaleString('en')
				} else {
					if(value > 0.1) {
						value = Math.round(value).toLocaleString('en')
					} else {
						value = value.toLocaleString('en', {minimumFractionDigits: 3})
					}
				}

				return value
			},
			rgb_pill(val, max) {
				const value = val * 255 / max;
				const color = value > 192 ? 192 : 64

				return {
					'color': 'rgb(' + color + ', ' + color + ', ' + color + ')',
					'background': 'rgb(' + value + ', ' + (255 - value) + ', ' + this.configuration.blue + ')'
				}
			},
			rgb_test_ping(server, instance, test) {
				const data = this.tests.ping.results[server][instance][0][test]
				return this.rgb_pill(data.value, data.limit)
			}
		}
	};
</script>

<style>
	#chart {
		width: 100%;
		height: 50vh;
	}

	.canvas {
		font-size: 1rem;
		line-height: 0.75rem;
		height: 100vh;
		padding: 1rem 0;
		display: grid;
		grid-template-columns: 100fr;
		grid-template-rows: 1fr auto 32fr;
		grid-template-areas:
		"config"
		"detail"
		"tests";
	}

	.config {
		grid-area: config;
		display: flex;
		justify-content: space-between;
		margin-bottom: 1rem;
	}

	.detail {
		grid-area: detail;
	}

	.tests {
		grid-area: tests;
	}

	.config > div {
		width: 100%;
		padding: 0 0.25rem;
	}

	.config button {
		width: 100%;
	}

	.ping-column {
		width: 1%;
		font-family: monospace;
		text-align: center !important;
		border-radius: 0.75rem;
		padding: 0.5rem !important;
		border: solid 0.25rem #fff !important;
		vertical-align: middle;
	}

	.ping-first-column {
		display: flex;
		justify-content: space-between;
		font-size: 0.666rem;
	}

	.ping-value {
		font-size: 0.75rem;
	}

	.ping-first-column > .ping-key {
		text-align: left;
	}

	.ping-first-column > .ping-key > div:first-child {
		font-size: 1rem;
	}

	.ping-first-column > .ping-value {
		text-align: right;
		font-size: 0.666rem;
	}

	@media (max-width: 850px) {
		.config {
			flex-direction: column;
		}
	}
</style>
